import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnDestroy {
  loaderVisible: boolean = false;
  private _apiSubscription: Subscription;

  constructor(private loader: LoaderServiceService) {
    this._apiSubscription = this.loader.showLoader.subscribe((data: boolean) =>{
      // setTimeout(() => {
      //   this.loaderVisible = data;
      // }, 100);
           this.loaderVisible = data;
    });
   }


  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
}
